import { ChevronDown, ArrowRight } from 'lucide-react'
import type { ArchitectureStep } from '../data/projects'

interface FlowDiagramProps {
  title: string
  steps: ArchitectureStep[]
  accentLabel?: string
}

const FlowDiagram: React.FC<FlowDiagramProps> = ({
  title,
  steps,
  accentLabel = 'request lifecycle',
}) => {
  return (
    <div className="diagram-shell p-5 sm:p-6">
      <div className="flex items-center justify-between mb-6">
        <span className="mono-label">{title}</span>
        <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-emerald-500">
          <span className="w-1 h-1 rounded-full bg-emerald-400" />
          {accentLabel}
        </span>
      </div>

      <ol className="flex flex-col md:flex-row md:flex-wrap md:items-stretch md:gap-2">
        {steps.map((step, i) => (
          <li key={step.label} className="contents">
            <div className="arch-node flex-1 md:min-w-[150px]">
              <span className="absolute top-2.5 left-2.5 font-mono text-[10px] text-neutral-400 dark:text-neutral-500">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="arch-node-title mt-3 block">{step.label}</span>
              {step.sub && <span className="arch-node-sub">{step.sub}</span>}
            </div>
            {i < steps.length - 1 && (
              <span
                aria-hidden="true"
                className="hidden md:flex arch-arrow !py-0 px-1 self-center"
              >
                <ArrowRight size={16} />
              </span>
            )}
            {i < steps.length - 1 && (
              <span aria-hidden="true" className="md:hidden arch-arrow relative">
                <ChevronDown size={14} />
                <span className="arch-pulse-dot absolute w-1.5 h-1.5 rounded-full bg-primary-400" />
              </span>
            )}
          </li>
        ))}
      </ol>
    </div>
  )
}

export default FlowDiagram